import { AppState, AppStateActionParams } from 'records/AppState';
import { BroadcastPayload } from 'records/broadcast';
import { ProjectId } from 'records/Project';
import { UserId } from 'records/User';
import { registerForEvents } from 'services/broadcastService';

export interface BroadcastActions {
  registerForFileEvents: (
    actionParams: AppStateActionParams,
    projectId: ProjectId,
    userId: UserId
  ) => Promise<AppState>;

  registerForDocumentProcessingEvents: (
    actionParams: AppStateActionParams,
    projectId: ProjectId,
    userId: UserId
  ) => Promise<AppState>;

  reregisterForEvents: (
    actionsParams: AppStateActionParams
  ) => Promise<AppState>;
}

const broadcastActions: BroadcastActions = {
  registerForFileEvents: async (
    { state }: AppStateActionParams,
    projectId: ProjectId,
    userId: UserId
  ): Promise<AppState> => {
    const payload = BroadcastPayload.deserialize({
      type: 'FileEvent',
      registertype: 'FileEvent',
      filter: projectId,
      userid: userId,
    });
    const result = await registerForEvents(payload);
    if (result) {
      return state().setIn(['registeredEvents', payload.registertype], payload);
    }
    return state();
  },
  registerForDocumentProcessingEvents: async (
    { state }: AppStateActionParams,
    projectId: ProjectId,
    userId: UserId
  ): Promise<AppState> => {
    const payload = BroadcastPayload.deserialize({
      type: 'DocumentProcessingEvent',
      registertype: 'DocumentProcessingEvent',
      filter: projectId,
      userid: userId,
    });
    const result = await registerForEvents(payload);
    if (result) {
      return state().setIn(['registeredEvents', payload.registertype], payload);
    }
    return state();
  },

  reregisterForEvents: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    state().registeredEvents.forEach(async (payload) => {
      await registerForEvents(payload);
    });

    return state();
  },
};

export default broadcastActions;
